var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-box"},[_c('div',{staticClass:"navbar"},[_c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-item"},[_c('i',{staticClass:"fa fa-sign-out",on:{"click":_vm.logout}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }